<template>
    <div>
        <main-modal
            :show-modal="showModal" 
            :footer="false"
            :title="view === 'rank' ? 'Project completion goals' : 'Share accomplishments'"
            size="md" 
            @close="$emit('cancel')"
        >
            <template #body>
                <div class="pb--5 overflow-y-scroll max-h-500">
                    <template v-if="view === 'rank'">
                        <div class="">
                            <div class="rank__group__text">
                                <p class="rank__group__text__desc">
                                    {{ computeRankDesc }} Completing a project can build up your skills, improve future risk assessments and help with feelings of confidence. 
                                    Remember, consistency is the modus operandi to achieve any great success!
                                </p>
                            </div>
                            <div class="rank__img">
                                <div v-for="(item) in rankingList" :key="item.name" class="rank__img__item" :class="{ 'active': item.name === currentRank }">
                                    <div class="rank__img__item__symbol">
                                        {{ item.symbol }}
                                    </div>

                                    <div class="rank__img__item__title">
                                        {{ item.name }}
                                    </div>
                                </div>
                            </div>
                            <div class="rank__desc">
                                <div class="rank__desc__text">
                                    Shoshinsha = <strong>Beginner</strong> level. Only <strong>five (5)</strong> projects completed.
                                </div>
                                <div class="rank__desc__text">
                                    Chukyu = <strong>Intermediate</strong> level. At least <strong>twenty (20)</strong> projects completed.
                                </div>
                                <div class="rank__desc__text">
                                    Sensei = <strong>Senior</strong> level. At least <strong>seventy (70)</strong> projects completed.
                                </div>
                                <div class="rank__desc__text mb--0">
                                    Shishou = <strong>Expert</strong> level. At least <strong>one hundred and fifty (150)</strong> projects completed.
                                </div>
                            </div>

                            <div class="rank__generate">
                                <h5 class="rank__group__text__title mb--0">
                                    Generate a work achievement list <span class="text-gray-500 text--normal">(coming soon)</span>
                                </h5>
                                <p class="rank__group__text__desc mt--3">
                                    Generate and publicly share a complied list of all your successful projects on LinkedIn for potential clients, friends or the general public.
                                </p>
                                <!-- <BaseButton 
                                    label="Continue" 
                                    class="rank__generate__btn" 
                                    size="sm"
                                    :loading="loading" 
                                    :disabled="completedProjectCount < 5"
                                    @submit="startProjectGeneration"
                                /> -->
                            </div>
                        </div>
                    </template>

                    <template v-else>
                        <div class="w-100">
                            <template v-if="projects.length">
                                <div class="flex-wrap rank__project__list">
                                    <div 
                                        v-for="project in projects" 
                                        :key="project._id" 
                                        class="rank__project__item"
                                    >                                
                                        <BaseCard shadow style="overflow: visible;">
                                            <template #card-body>
                                                <div class="">
                                                    <div class="flex align-items-center">
                                                        <div class="left">
                                                            <div class="form-check mb--0">
                                                                <input 
                                                                    :id="project._id"
                                                                    v-model="selectedProjects" class="form-check-input" 
                                                                    type="checkbox" :value="project._id"
                                                                >
                                                                <FormLabel :title="project.title" :html-for="`${project.title}`" label-type="menu" />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div v-if="project.links && project.links.length">
                                                        <div class="dropdown">
                                                            <BaseButton 
                                                                id="projectDropDown" 
                                                                data-bs-toggle="dropdown" 
                                                                aria-expanded="false"
                                                                label="+ Select main link"
                                                                variant="ghost" 
                                                                variant-style="primary"
                                                            />

                                                            <List id="projectLink">
                                                                <ListItem v-for="link in project.links" :key="link._id" class="flex align-items-center" @click="setProjectLink(link, project._id)">
                                                                    <IconSvg name="link" fill="#64748B" width="16px" />
                                                                    <span class="ml--10 text--xs text--capitalize">{{ link.name }}</span>
                                                                </ListItem>
                                                            </List>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div>
                                                    <p class="text--sm text-gray-600 mt--5">
                                                        {{ project.baseLink }}
                                                    </p>
                                                </div>
                                            </template>
                                        </BaseCard>
                                    </div>
                                </div>
                            </template>

                            <template v-else>
                                <EmptyPage
                                    state="empty_custom" 
                                    icon-name="folder" 
                                    type="project"
                                    title="No projects" 
                                    subtitle="You have no projects to share. To get started, create and complete at least one existing project"
                                />
                            </template>

                            <div class="mt--15 w-100 flex justify-content-center">
                                <BaseButton
                                    label="Go back" 
                                    variant="ghost" 
                                    prefix-icon
                                    icon-name="chevrons-left"
                                    variant-style="primary"
                                    @submit="view = 'rank'"
                                />
                            </div>
                        </div>
                    </template>
                </div>
            </template>
        </main-modal>
    </div>
</template>

<script>
import MainModal from "./MainModal.vue";
import IconSvg from "../icons/Icon-Svg.vue";
import { rankingList, rankObj } from "@/utils/dummy";
import BaseButton from "../buttons/BaseButton.vue";
import EmptyPage from "../emptyPage/EmptyPage.vue";
import List from "../lists/List.vue";
import ListItem from "../lists/ListItem.vue";
import BaseCard from "../card/BaseCard.vue";
import FormLabel from "../forms/FormLabel.vue";

export default {
    name: "Rank",

    components: {
        MainModal,
        BaseButton,
        EmptyPage,
        IconSvg,
        ListItem,
        List,
        BaseCard,
        FormLabel,
    },

    props: {
        showModal: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            rankingList,
            loading: false,
            view: "rank",
            fetchErr: false,
            fetchErrMsg: "",
            searchProjectLoading: false,
            selectedProjects: [], // { title: "", _id: "", baseLink: "" }
        };
    },

    computed: {
        projects() {
            return this.$store.getters["project/projects"];
        },

        pdfFile() {
            return this.$store.getters["app/pdfFile"];
        },

        completedProjectCount() {
            return this.$store.getters["app/completedProjectCount"];
        },

        currentRank() {
            if (this.completedProjectCount >= 5 && (this.completedProjectCount < 20)) {
                return "Shoshinsha";
            } else if (this.completedProjectCount >= 20 && (this.completedProjectCount < 70)) {
                return "Chūkyū";
            } else if (this.completedProjectCount >= 70 && (this.completedProjectCount < 150)) {
                return "Sensei";
            } else if (this.completedProjectCount >= 150) {
                return "Shishou";
            } else {
                return "";
            }
        },

        computeRankDesc() {
            return rankObj[this.currentRank] || "You are yet to complete up to 5 projects.";
        },
    },
    
    methods: {
        async startProjectGeneration() {
            try {
                this.loading = true;
                
                // await this.$store.dispatch("app/generatePdf");

                this.view = "share";
            } catch (error) {
                
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss">
.rank {
    &__project {
        &__list {
            display: flex;
            flex-wrap: wrap;
            gap: 1rem;
            display: grid;
            grid-template-columns: 1fr;
        }

        &__item {
            flex: 1;
            margin-bottom: 15px;
            
            &:not(:last-of-type) {
                margin-right: 1rem;
            }
        }
    }

    &__group {
        &__text {
            &__title {
                color: #374151;
                font-size: 0.875rem;
                font-weight: 700;
            }

            &__desc {
                color: #667085;
                color: #1A202C;
                font-size: 0.875rem;
            }
        }
    }

    &__img {
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        margin-top: 1.8rem;

        &__item {
            color: #64748B;
            font-size: 0.875rem;  
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;  
            max-width: 72px;
            position: relative;

            &:not(:last-of-type) {
                &::after {
                    min-width: 66px;
                    border-color: inherit;
                    height: 2px;
                    content: '';
                    position: absolute;
                    left: 100%;
                    bottom: 61%;
                    background: #A3B4D0;
                }
            }
            
            &__symbol {
                width: 72px;
                height: 72px;
                border-radius: 7px;
                border: 1px solid #A3B4D0;
                display: flex;
                align-items: center;
                padding: 10px;
                justify-content: center;

                &.active {
                    border: 1px solid #137B87;
                }
            }

            &__title {
                margin-top: 10px;
                text-align: center
            }

            &.active {
                color: #137B87;
                font-weight: 600;

                .rank__img__item__symbol {
                    border: 2px solid #137B87;
                }

                &::after {
                    background: #137B87;
                }
            }

            &__award {
                position: absolute;
                z-index: 10000;
                top: -19%;
                left: -41%;
            }
        }
    }

    &__desc {
        background: #F7F7F7;
        border-radius: 7px;
        padding: 15px;
        margin-top: 1.5rem;

        &__text {
            color: #3F3D56;
            margin-bottom: 10px;
            font-size: 0.875rem;
        }
    }

    &__generate {
        margin-top: 1.5rem;

        &__btn {
            margin-top: 1rem;
        }
    }
}
</style>